$(".menu__accordion-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".menu__accordion-content").slideUp();
    } else {
        $(".menu__accordion-content").slideUp();
        $(".menu__accordion-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".menu__accordion-content").slideDown();
    }
})


$(".feather-menu").on('click', function () {
    $("body").addClass('menu-active');
})
$(".menu__close").on('click', function () {
    $("body").removeClass('menu-active');
})




document.querySelectorAll('.has-sub-menu > a').forEach(anchor => {
    anchor.addEventListener('click', e => {
        e.preventDefault(); // prevent jump on href="#"

        const parentLi = anchor.closest('.has-sub-menu');
        const subNav = parentLi.querySelector('.menu__second-nav');

        if (subNav) {
            subNav.classList.add('menu--active');
        }
    });
});



// Tab switching logic
const tabButtons = document.querySelectorAll('.menu__top-wrap button');
const menuSections = document.querySelectorAll('.menu__plants');

tabButtons.forEach(button => {
    button.addEventListener('click', () => {
        const type = button.getAttribute('data-type');

        // Toggle content
        menuSections.forEach(section => {
            section.classList.toggle('active', section.getAttribute('data-type') === type);
        });

        // Toggle active class on buttons
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    });
});

// Show first tab by default
document.addEventListener('DOMContentLoaded', () => {
    const firstBtn = document.querySelector('.menu__top-wrap button');
    if (firstBtn) firstBtn.click();
});

// // Back to main menu
// document.querySelector('.menu__second-nav-item-top img')?.addEventListener('click', () => {
//     document.querySelector('.menu__wrap').classList.remove('menu--hidden');
//     document.querySelector('.menu__second-nav').classList.remove('menu--active');
// });
document.querySelectorAll('.menu__second-nav-item-top img').forEach(img => {
  img.addEventListener('click', () => {
    // Show the main menu
    document.querySelector('.menu__wrap').classList.remove('menu--hidden');
    // Hide only the current .menu__second-nav
    const subNav = img.closest('.menu__second-nav');
    if (subNav) {
      subNav.classList.remove('menu--active');
    }
  });
});

